<template>
  <Landing />
</template>

<script>
import Landing from '@/components/pages/Landing'

export default {
  components: {
    Landing
  }
}
</script>
